import { ReduxBaseActions } from '../../redux-base';

export class TagCreateActions extends ReduxBaseActions {
  getInitialActionCommandName(): string {
    return 'CREATE_ACTION';
  }

  getClassName(): string {
    return 'TAG_CREATE';
  }
}
